import React, {PureComponent} from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'
import injectStyles from "react-jss"
import {getUniversalCategories} from "../../selectors"

class MainMenu extends PureComponent {

    getCategoryUrl = (category) => {
        return category.url || '/';
    }

    render() {
        const {classes, categories} = this.props;
        if(!categories) return null;

        return <nav className={classes.nav} >
            <div className={classes.scrollableContainer}>
                <ul className={cn(classes.links, classes.scrollable)}>
                    {categories.map(category => (
                        <li key={category.category}>
                            <a className='ga-track-link-click'
                               href={this.getCategoryUrl(category)}
                               data-ga-category={category.ga_category} data-ga-action={category.ga_action} data-ga-label={category.ga_label}>{category.title}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    }
}
const mapStateToProps = (state) => {
    return {
        categories: getUniversalCategories(state),
    }
}

export default injectStyles((theme) => ({
    nav: {
        textAlign: 'center'
    },
    scrollableContainer: {
        position: 'relative',
        "&:before": {
            content: "''",
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            width: 64,
            pointerEvents: 'none',
            //z-index: 10;
            background: 'linear-gradient(to right,rgba(35,35,35,0) 0,#232323 100%)'
        }
    },
    scrollable: {
        overflowX: 'scroll',
        '-webkit-overflow-scrolling': 'touch',
        [theme.breakpoint('tablet')]: {
            overflowX: 'inherit'
        },
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    }, 
    links: {
        listStyle: 'none',
        padding: `0 ${theme.convertFromIconicRemValue(0.625)}`,
        fontWeight: '400',
        textTransform: 'uppercase',
        letterSpacing: theme.convertFromIconicRemValue(0.01875),
        whiteSpace: 'nowrap',
        margin: 'auto',
        height: 49,
        '& li': {
            display: 'inline-block',
        },
        '& li a': {
            userSelect: 'none',
            display: 'inline-block',
            textDecoration: 'none',
            color: theme.colors.white,
            fontWeight: 400,
            fontSize: theme.convertFromIconicRemValue(0.6875),
            lineHeight: theme.convertFromIconicRemValue(1),
            padding: `${theme.convertFromIconicRemValue(0.875)} ${theme.convertFromIconicRemValue(0.375)}`,
            '&:hover': {
                color: theme.colors.primary
            },
            "&.selected": {
                color: theme.colors.primary
            },
            [theme.breakpoint('tablet')]: {
                fontSize: theme.convertFromIconicRemValue(0.8125),
                padding: `${theme.convertFromIconicRemValue(1.025)} ${theme.convertFromIconicRemValue(0.5)}`,
            }
        }
    },

}))(connect(mapStateToProps)(MainMenu))



// WEBPACK FOOTER //
// ./src/components/UniversalNav/MainMenu.js